/* SET STATE */
export const SET_STATE_LABREQUEST = "SET_STATE_LABREQUEST"

/* LABREQUESTS */
export const GET_LABREQUESTS = "GET_LABREQUESTS"
export const GET_LABREQUESTS_SUCCESS = "GET_LABREQUESTS_SUCCESS"
export const GET_LABREQUESTS_FAIL = "GET_LABREQUESTS_FAIL"

/* LABREQUESTS */
export const GET_LABREQUESTSREPORTDETAIL = "GET_LABREQUESTSREPORTDETAIL"
export const GET_LABREQUESTSREPORTDETAIL_SUCCESS = "GET_LABREQUESTSREPORTDETAIL_SUCCESS"
export const GET_LABREQUESTSREPORTDETAIL_FAIL = "GET_LABREQUESTSREPORTDETAIL_FAIL"

/* LABREQUEST */
export const GET_LABREQUEST = "GET_LABREQUEST"
export const GET_LABREQUEST_SUCCESS = "GET_LABREQUEST_SUCCESS"
export const GET_LABREQUEST_FAIL = "GET_LABREQUEST_FAIL"

/**
 * ADD LABREQUEST
 */
 export const ADD_NEW_LABREQUEST = "ADD_NEW_LABREQUEST"
 export const ADD_LABREQUEST_SUCCESS = "ADD_LABREQUEST_SUCCESS"
 export const ADD_LABREQUEST_FAIL = "ADD_LABREQUEST_FAIL"

 /**
 * UPDATE LABREQUEST
 */
export const UPDATE_LABREQUEST = "UPDATE_LABREQUEST"
export const UPDATE_LABREQUEST_SUCCESS = "UPDATE_LABREQUEST_SUCCESS"
export const UPDATE_LABREQUEST_FAIL = "UPDATE_LABREQUEST_FAIL"

/**
 * DELETE LABREQUEST
 */
export const DELETE_LABREQUEST = "DELETE_LABREQUEST"
export const DELETE_LABREQUEST_SUCCESS = "DELETE_LABREQUEST_SUCCESS"
export const DELETE_LABREQUEST_FAIL = "DELETE_LABREQUEST_FAIL"
